import { RouteConfig } from 'vue-router'
const OlympicIndex = () => import('../activity/202407/olympic/Index.vue')
const OlympicRank = () => import('../activity/202407/olympic/Rank.vue')
const OlympicBoard = () => import('../activity/202407/olympic/Board.vue')
const OlympicUserScore = () => import('../activity/202407/olympic/UserScore.vue')
const OlympicUserScoreHistory = () => import('../activity/202407/olympic/UserScoreHistory.vue')
const OlympicMatchList = () => import('../activity/202407/olympic/MatchList.vue')
const OlympicAward = () => import('../activity/202407/olympic/Award.vue')

export const A202407OlympicIndex: RouteConfig = {
  path: '/activity/202407/olympic/index',
  name: 'activity_202407_olympic_index',
  component: OlympicIndex,
  meta: {
    title: '奥运同步赛',
    expiryDate: '2024-08-30',
  },
  props: (route) => ({ ...route.query }),
}
export const A202407OlympicRank: RouteConfig = {
  path: '/activity/202407/olympic/rank',
  name: 'activity_202407_olympic_rank',
  component: OlympicRank,
  meta: {
    title: '排行榜',
    expiryDate: '2024-08-30',
  },
  props: (route) => ({ ...route.query }),
}

export const A202407OlympicBoard: RouteConfig = {
  path: '/activity/202407/olympic/board',
  name: 'activity_202407_olympic_board',
  component: OlympicBoard,
  meta: {
    title: '奖牌榜',
    expiryDate: '2024-08-30',
  },
  props: (route) => ({ ...route.query }),
}
export const A202407OlympicUserScore: RouteConfig = {
  path: '/activity/202407/olympic/user_score',
  name: 'activity_202407_olympic_user_score',
  component: OlympicUserScore,
  meta: {
    title: '兑换礼品',
    expiryDate: '2024-08-30',
  },
  props: (route) => ({ ...route.query }),
}
export const A202407OlympicUserScoreHistory: RouteConfig = {
  path: '/activity/202407/olympic/user_score_history',
  name: 'activity_202407_olympic_user_score_history',
  component: OlympicUserScoreHistory,
  meta: {
    title: '积分记录',
    expiryDate: '2024-08-30',
  },
  props: (route) => ({ ...route.query }),
}

export const A202407OlympicMatchList: RouteConfig = {
  path: '/activity/202407/olympic/match_list',
  name: 'activity_202407_olympic_match_list',
  component: OlympicMatchList,
  meta: {
    title: '奥运同步赛',
    expiryDate: '2024-08-30',
  },
  props: (route) => ({ ...route.query }),
}

export const A202407OlympicAward: RouteConfig = {
  path: '/activity/202407/olympic/award',
  name: 'activity_202407_olympic_award',
  component: OlympicAward,
  meta: {
    title: '获奖记录',
    expiryDate: '2024-08-30',
  },
  props: (route) => ({ ...route.query }),
}

export default [
  A202407OlympicIndex,
  A202407OlympicBoard,
  A202407OlympicRank,
  A202407OlympicUserScore,
  A202407OlympicUserScoreHistory,
  A202407OlympicMatchList,
  A202407OlympicAward,
]
